export default __webpack_public_path__ + "images/42bf36a45a15eba4d8c32f815fa6fe7e.png";